import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { isNil, isEmpty } from 'ramda';

import {
  initialValues as updateInitialValues,
  validationSchema as updateValidationSchema,
} from '../../../../forms/supportRequests/updateForm';
import {
  initialValues as closeInitialValues,
  validationSchema as closeValidationSchema,
} from '../../../../forms/supportRequests/closeForm';
import SupportRequestPresenter from '../../../../presenters/SupportRequestPresenter';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TextInput from '../../../../components/TextInput';
import TextAreaInput from '../../../../components/TextAreaInput';

const EditRequestModal = (props) => {
  const {
    request,
    isOpen,
    onClose,
    onRequestUpdate,
    formType,
    updateFormType,
    closeFormType,
  } = props;

  const isUpdateForm = formType === updateFormType;
  const isCloseForm = formType === closeFormType;

  const handleRequestUpdate = async (values) => {
    const params = {
      id: SupportRequestPresenter.id(request),
      supportRequest: values,
    };

    await onRequestUpdate(params);
    onClose();
  };

  const getFormParams = () => {
    if (isUpdateForm) {
      return {
        initialValues: updateInitialValues(request),
        validationSchema: updateValidationSchema,
        reviewerCommentLabel: 'Comment',
        modalTitle: 'Edit Support Request',
      };
    }

    const params = {
      initialValues: closeInitialValues(request),
      validationSchema: closeValidationSchema,
      reviewerCommentLabel: 'Please describe what has been done',
      modalTitle: 'Close Support Request',
    };

    return params;
  };

  const { initialValues, validationSchema, reviewerCommentLabel, modalTitle } =
    getFormParams();

  const formik = useFormik({
    initialValues,
    onSubmit: handleRequestUpdate,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
  });

  const { handleSubmit, setFieldValue, values, errors } = formik;

  const handleChange = ({ target }) => {
    const { id, value } = target;

    setFieldValue(id, value);
  };

  const isSubmitDisabled = isCloseForm && isEmpty(values.reviewerComment);

  return (
    <Modal title={modalTitle} onClose={onClose} isModalOpen={isOpen}>
      <form onSubmit={handleSubmit}>
        {isUpdateForm && (
          <TextInput
            id="plaidTicketUrl"
            label="Plaid Ticket Url"
            value={values.plaidTicketUrl}
            onChange={handleChange}
          />
        )}
        <TextAreaInput
          id="reviewerComment"
          label={reviewerCommentLabel}
          value={values.reviewerComment}
          onChange={handleChange}
        />
        <div className="modal-actions">
          <Button
            className="modal-save"
            type="submit"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
            Save Changes
          </Button>
          <Button className="modal-close" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};

EditRequestModal.propTypes = {
  request: SupportRequestPresenter.shape(),
  isOpen: PropTypes.bool.isRequired,
  onRequestUpdate: PropTypes.func.isRequired,
  formType: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  updateFormType: PropTypes.string.isRequired,
  closeFormType: PropTypes.string.isRequired,
};

export default EditRequestModal;

EditRequestModal.defaultProps = {
  request: null,
};
